/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import {
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(() => ({
  resize: {
    padding: 14,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "#1558a2",
    fontWeight: 700,
    marginRight: 10,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "right",
  },
}));

const ChangeStatusDispute = (props) => {
  const {
    handleClose,
    open,
    state,
    onSaveClick,
    onHandleChange,
    setVoucherAmountType,
    setEffectiveFrom,
    setEffectiveTo,
  } = props;
  const classes = useStyles();

  useEffect(() => {
    if (!open) {
      // setDisputedItemRemarks("");
      // setVoucherAmountType("");
      // setVoucherPercentage("");
      // setVoucherAmount("");
      // setEffectiveVoucherFrom("");
      // setEffectiveVoucherTo("");
    }
  }, [open]);

  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={open}
        disableBackdropClick
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >{`Order# ${state.selectedOrder.orderId} `}</span>
          </Fragment>
        }
        content={
          <Fragment>
            {state.actionTypeId == 100 ? (
              <>
                <div>
                  {/*Voucher Amount Type*/}
                  {/*1-> Percentage*/}
                  {/*2-> Amount*/}
                  <RadioGroup
                    row
                    aria-label="voucherAmountType"
                    name="voucherAmountType"
                    value={state.voucherAmountType}
                    onChange={(e) => setVoucherAmountType(e)}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio style={{ color: "#3f51b5" }} />}
                      label="Percentage"
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio style={{ color: "#3f51b5" }} />}
                      label="Amount"
                    />
                  </RadioGroup>

                  <div style={{ width: "100%", marginBottom: 20 }}>
                    {state.voucherAmountType === "1" ? (
                      <FormControl
                        sx={{ m: 1, width: "25ch" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          type={"tel"}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          name={"voucherPercentage"}
                          value={state.voucherPercentage}
                          endAdornment={
                            <InputAdornment position="end">%</InputAdornment>
                          }
                          aria-describedby="outlined-weight-helper-text"
                          inputProps={{
                            "aria-label": "weight",
                          }}
                          onChange={(e) => onHandleChange(e)}
                        />
                      </FormControl>
                    ) : (
                      <FormControl
                        sx={{ m: 1, width: "25ch" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          type={"tel"}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          name={"voucherAmount"}
                          value={state.voucherAmount}
                          endAdornment={
                            <InputAdornment position="end">Rs</InputAdornment>
                          }
                          aria-describedby="outlined-weight-helper-text"
                          inputProps={{
                            "aria-label": "weight",
                          }}
                          onChange={(e) => onHandleChange(e)}
                        />
                      </FormControl>
                    )}
                  </div>

                  <Grid container direction="row" spacing={1}>
                    <Grid item xs={6}>
                      <span>
                        <TextField
                          fullWidth
                          id="date"
                          name="effectiveVoucherFrom"
                          label="Effective from"
                          type="date"
                          variant={"outlined"}
                          defaultValue={state.effectiveVoucherFrom}
                          onChange={(date) => {
                            setEffectiveFrom(date);
                          }}
                          // onChange={(e) => onHandleChange(e)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </span>
                    </Grid>
                    <Grid item xs={6}>
                      <span>
                        <TextField
                          id="date"
                          label="Effective to"
                          name="effectiveVoucherTo"
                          type="date"
                          variant={"outlined"}
                          fullWidth
                          defaultValue={state.effectiveVoucherTo}
                          onChange={(date) => {
                            setEffectiveTo(date);
                          }}
                          // onChange={(e) => onHandleChange(e)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </span>
                    </Grid>
                  </Grid>
                </div>
                <br />
                <div>
                  <Grid xs={12}>
                    <TextField
                      id="voucher-usage-limit"
                      variant="outlined"
                      value={state.disputedItemRemarks}
                      label={"Remarks"}
                      multiline
                      rows={4}
                      name={"disputedItemRemarks"}
                      fullWidth
                      onChange={(e) => onHandleChange(e)}
                    />
                  </Grid>
                </div>
                <div className={classes.actions}>
                  {/* <Button onClick={() => onSaveClick(state.actionTypeDisputedId,state.orderItemId,disputedItemRemarks,voucherAmountType,voucherPercentage,voucherAmount)} disabled={state.onCancelItemStatusLoading}  variant="contained" color="primary" >
                                        {state.onCancelItemStatusLoading ? <CircularProgress size={30} /> : 'Save'}
                                    </Button> */}
                  <Button
                    onClick={() =>
                      onSaveClick(state.actionTypeId, state.orderItemId)
                    }
                    disabled={state.onCancelItemStatusLoading}
                    variant="contained"
                    color="primary"
                  >
                    {state.onCancelItemStatusLoading ? (
                      <CircularProgress size={30} />
                    ) : (
                      "Save"
                    )}
                  </Button>
                  <Button
                    disabled={state.onCancelItemStatusLoading}
                    style={{ marginLeft: 20 }}
                    onClick={() => handleClose()}
                    variant="contained"
                  >
                    Cancel
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div>
                  <span
                    style={{
                      fontSize: 18,
                      color: "#1558a2",
                      fontWeight: 700,
                    }}
                  >
                    {state.actionTypeId == 10
                      ? "Are you sure, you want to Accept?"
                      : "Are you sure, you want to Reject ?"}
                  </span>
                </div>
                <br />
                <div>
                  <Grid xs={12}>
                    <TextField
                      id="voucher-usage-limit"
                      variant="outlined"
                      //    style={{width: "245px"}}
                      value={state.disputedItemRemarks}
                      label={"Remarks"}
                      multiline
                      rows={4}
                      name={"disputedItemRemarks"}
                      fullWidth
                      onChange={(e) => onHandleChange(e)}
                    />
                  </Grid>
                </div>
                <div className={classes.actions}>
                  <Button
                    onClick={() =>
                      onSaveClick(state.actionTypeId, state.orderItemId)
                    }
                    disabled={state.onCancelItemStatusLoading}
                    variant="contained"
                    color="primary"
                  >
                    {state.onCancelItemStatusLoading ? (
                      <CircularProgress size={30} />
                    ) : (
                      "Yes"
                    )}
                  </Button>
                  {/* <Button onClick={() => onSaveClick(state.actionTypeDisputedId,state.orderItemId,disputedItemRemarks,voucherAmountType,voucherPercentage,voucherAmount)} disabled={state.onCancelItemStatusLoading}  variant="contained" color="primary" >
                                        {state.onCancelItemStatusLoading ? <CircularProgress size={30} /> : 'Yes'}
                                    </Button> */}
                  <Button
                    disabled={state.onCancelItemStatusLoading}
                    style={{ marginLeft: 20 }}
                    onClick={() => handleClose()}
                    variant="contained"
                  >
                    No
                  </Button>
                </div>
              </>
            )}
          </Fragment>
        }
      />
    </Fragment>
  );
};

ChangeStatusDispute.propTypes = {
  handleClose: PropTypes.func,
  onSaveClick: PropTypes.func,
  onHandleChange: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

ChangeStatusDispute.defaultProps = {
  handleClose: (fn) => fn,
  onSaveClick: (fn) => fn,
  onHandleChange: (fn) => fn,
  open: false,
  state: {},
};

export default ChangeStatusDispute;
